// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { ILocationResponse } from 'common/api/resources/Location';
import { Icon } from '@plesk/ui-library';
import {
    ICONS,
    INTENT_TYPE,
} from 'common/constants';
import { IconWrapper } from 'common/components/IconCell/Styles';

export interface ILocationCellProps {
    location: ILocationResponse;
    color?: string;
    adaptive?: boolean;
}

const LocationCell: React.FC<ILocationCellProps> = ({
    location,
    color,
    adaptive = false,
}) => {
    const renderIcon = () => {
        if (location.icon) {
            return (
                <IconWrapper color={color} $adaptive={adaptive}>
                    <img width={16} src={location.icon.url} alt={location.icon.name}/>
                    <span className="location-name">{location.name}</span>
                </IconWrapper>
            );
        }

        return (
            <IconWrapper color={color} $adaptive={adaptive}>
                <Icon
                    intent={INTENT_TYPE.INACTIVE}
                    name={ICONS.GLOBE}
                />
                <span className="location-name">{location.name}</span>
            </IconWrapper>
        );
    };

    return renderIcon();
};

export default LocationCell;
